<script lang="ts">
    import { resolve } from '$app/paths'
    import FaArrowRight from '~icons/fa-solid/arrow-right'
</script>

<a class="blog-try-button" href={resolve('/projects/create')}>
    Try ASM Editor
    <span class="blog-link-icon" aria-hidden="true"><FaArrowRight /></span>
</a>
